import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";
import BackgroundImage from "../components/BackgroundImage";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import DottedLine from "../components/DottedLine";
import {
  faMagicWandSparkles,
  faRocket,
  faBrain,
  faHandshake,
  faPhone,
  faGear,
  faTruckFast,
  faChartLine,
  faMobileScreen,
  faLightbulb,
  faHammer,
  faWrench,
  faMicrochip,
  faDatabase,
  faEarthAmericas,
} from "@fortawesome/free-solid-svg-icons";

export default function Roadmap() {
  const { t } = useTranslation();
  return (
    <div className="page-wrapper">
      <BackgroundImage />
      <NavBar />
      <div className="transparency-wrapper">
        {/* ROADMAP */}
        <section className="section-block column">
          <div className="section-text-centered-wrapper no-margin-top">
            <div className="section-title-centered neon-glow">
              A CLEAR PATH FORWARD
            </div>
            <div className="section-subtitle-centered cyan">
              FROM IDEA TO LAUNCH
            </div>
            <p className="section-text-secondary max-w-3xl mx-auto">
              I have a straightforward defined process so you can know what to
              expect at every point of the project. I offer a clean, structured
              and transparent roadmap so we can have both piece of mind and
              alignment throughout our collaboration.
            </p>
          </div>

          <div className="roadmap-grid">
            <DottedLine
              totalDots={45}
              iconMap={{
                /* Discovery & Alignment */
                2: { icon: faLightbulb },
                4: { icon: faPhone },
                6: { icon: faHandshake },
                /* Design & Prototype */
                11: { icon: faBrain },
                13: { icon: faGear },
                15: { icon: faMagicWandSparkles },
                /* Build & Iterate */
                20: { icon: faHammer },
                22: { icon: faMicrochip },
                24: { icon: faMobileScreen },
                /* Launch & Scale */
                29: { icon: faRocket },
                31: { icon: faEarthAmericas },
                33: { icon: faTruckFast },
                /* Ongoing Support */
                38: { icon: faWrench },
                40: { icon: faDatabase },
                42: { icon: faChartLine },
              }}
            />
            <div className="empty-space"></div>
            <div className="roadmap-card half-box push-right card-box equal-height-5">
              <div className="section-text-main">Discovery & Alignment</div>
              <p className="section-text-secondary">
                Once you submit the contact form, I’ll reach out within 24 hours
                to schedule a call so you can walk me through your idea,
                objectives, and constraints. Based on the outcome of our
                conversation, I will provide you with a clear, written quotation
                which covers scope, costs, timeline and technical details of my
                offer. This part of the process is free of cost for you and it
                can be revised both at this or future stages.
              </p>
            </div>

            <div className="roadmap-card half-box push-left card-box equal-height-5">
              <div className="section-text-main">Design & Prototype</div>
              <p className="section-text-secondary">
                Once we have an agreement, I start with the development. The
                goal here is to deliver a working prototype. A PoC, MVP, or
                early version of the product that can be tested and evaluated.
                It could be a mobile app bundle, firmware on off-the-shelf
                hardware, or a small production run of custom PCBs. We'll have
                regular check-ins to track progress and make adjustments.
              </p>
            </div>

            <div className="roadmap-card half-box push-right card-box equal-height-5">
              <div className="section-text-main">Build & Iterate</div>
              <p className="section-text-secondary">
                After the prototype is validated, we move into the main build.
                This stage focuses on stability, performance, and completeness.
                For apps, refined UI, smooth UX, and comprehensive testing. For
                hardware or firmware, that means optimization, robustness, and
                production readiness. Every part is finalized for real-world
                use.
              </p>
            </div>

            <div className="roadmap-card half-box push-left card-box equal-height-5">
              <div className="section-text-main">Launch & Scale</div>
              <p className="section-text-secondary">
                Once the product is ready, we handle the transition to
                production. That might include publishing to app stores,
                preparing for mass manufacturing, setting up infrastructure,
                creating a landing page, or launching an ad campaign. We adapt
                to your particular goals and make sure the product is ready for
                real users and real growth.
              </p>
            </div>

            <div className="roadmap-card half-box push-right card-box equal-height-5">
              <div className="section-text-main">Ongoing Support</div>
              <p className="section-text-secondary">
                Support continues post-launch if required. I can provide
                maintenance, feature updates, performance improvements,
                infrastructure scaling, and long-term versioning. Whether it’s
                occasional work or continuous development, I stay available for
                what comes next.
              </p>
            </div>
            <div className="bottom-space"></div>
          </div>

          <div className="cta-button-secondary-wrapper">
            <Link
              to="/quote"
              className="cta-button-secondary"
              onClick={() => trackCTA("roadmap")}
            >
              {t("ctaBookCall")}
            </Link>
          </div>
        </section>
        {/**/}

        <Footer />
      </div>
    </div>
  );
}
